import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common'; // <-- this is needed

@Component({
  selector: 'app-expense-summary-card',
  imports: [CommonModule],
  templateUrl: './expense-summary-card.component.html',
})
export class ExpenseSummaryCardComponent {
  @Input() icon = '';
  @Input() iconColor = '';
  @Input() borderColor = '';
  @Input() label = '';
  @Input() amount = 0;
  @Input() count = 0;
}
